import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ProcessPage() {
  const steps = [
    {
      number: '01',
      icon: 'ri-chat-smile-3-fill',
      title: 'Premier entretien gratuit',
      description: 'Compréhension approfondie de votre projet et évaluation complète de votre profil académique et professionnel.',
      duration: '1 heure',
      color: 'from-blue-500 to-blue-600'
    },
    {
      number: '02',
      icon: 'ri-search-eye-fill',
      title: 'Sélection des programmes adaptés',
      description: 'Analyse détaillée et identification des meilleures options académiques correspondant à vos objectifs de carrière.',
      duration: '3-5 jours',
      color: 'from-green-500 to-green-600'
    },
    {
      number: '03',
      icon: 'ri-file-list-3-fill',
      title: 'Montage du dossier d\'admission',
      description: 'Constitution professionnelle et organisée de candidatures optimisées pour maximiser vos chances de succès.',
      duration: '2-3 semaines',
      color: 'from-purple-500 to-purple-600'
    },
    {
      number: '04',
      icon: 'ri-mail-check-fill',
      title: 'Obtention de la lettre d\'admission',
      description: 'Vérification minutieuse de votre admission et préparation immédiate pour l\'étape suivante du processus.',
      duration: '4-12 semaines',
      color: 'from-orange-500 to-orange-600'
    },
    {
      number: '05',
      icon: 'ri-passport-fill',
      title: 'Demande de visa et orientation pré-départ',
      description: 'Préparation administrative complète et sessions pratiques pour votre installation dans le pays d\'accueil.',
      duration: '4-8 semaines',
      color: 'from-red-500 to-red-600'
    },
    {
      number: '06',
      icon: 'ri-customer-service-2-fill',
      title: 'Suivi après arrivée',
      description: 'Assistance continue et soutien permanent jusqu\'à votre pleine intégration et réussite académique.',
      duration: 'Permanent',
      color: 'from-teal-500 to-teal-600'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="bg-gradient-to-r from-[#003D82] to-[#0052AD] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Processus d'accompagnement</h1>
          <div className="w-24 h-1 bg-[#FF6B35] mb-6"></div>
          <p className="text-xl max-w-4xl leading-relaxed text-white/90">
            Un parcours clair, structuré et sécurisant pour transformer votre rêve d'études à l'étranger en réalité. Chaque étape est soigneusement planifiée pour garantir votre succès.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative">
            <div className="absolute left-8 top-0 bottom-0 w-1 bg-gradient-to-b from-[#FF6B35] to-[#003D82] hidden lg:block"></div>

            <div className="space-y-12">
              {steps.map((step, index) => (
                <div key={index} className="relative">
                  <div className="flex flex-col lg:flex-row gap-8 items-start">
                    <div className="lg:w-20 flex-shrink-0">
                      <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center text-white text-2xl font-bold shadow-lg relative z-10`}>
                        {step.number}
                      </div>
                    </div>

                    <div className="flex-1 bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all border-2 border-transparent hover:border-[#FF6B35]">
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex items-center gap-4">
                          <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl shadow-md">
                            <i className={`${step.icon} text-3xl text-[#FF6B35]`}></i>
                          </div>
                          <div>
                            <h3 className="text-2xl font-bold text-[#003D82]">{step.title}</h3>
                            <span className="inline-block mt-1 px-3 py-1 bg-[#FF6B35]/10 text-[#FF6B35] text-sm font-semibold rounded-full">
                              <i className="ri-time-fill mr-1"></i>
                              {step.duration}
                            </span>
                          </div>
                        </div>
                      </div>
                      <p className="text-gray-700 leading-relaxed text-lg">{step.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-xl p-12">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-[#003D82] mb-4">Pourquoi suivre notre processus ?</h2>
              <div className="w-24 h-1 bg-[#FF6B35] mx-auto"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mx-auto mb-4">
                  <i className="ri-shield-check-fill text-4xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#003D82] mb-3">Sécurité garantie</h3>
                <p className="text-gray-600">Chaque étape est validée avant de passer à la suivante pour minimiser les risques.</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mx-auto mb-4">
                  <i className="ri-time-fill text-4xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#003D82] mb-3">Gain de temps</h3>
                <p className="text-gray-600">Notre expertise vous évite les erreurs coûteuses et accélère votre projet.</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mx-auto mb-4">
                  <i className="ri-trophy-fill text-4xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#003D82] mb-3">Taux de réussite élevé</h3>
                <p className="text-gray-600">Notre méthodologie éprouvée maximise vos chances d'admission et d'obtention du visa.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#003D82] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Commencez votre parcours aujourd'hui</h2>
          <p className="text-xl mb-8 text-white/90">
            Réservez votre premier entretien gratuit et découvrez comment nous pouvons vous aider à réaliser votre projet.
          </p>
          <button
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-[#FF6B35] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#FF6B35]/90 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center"
          >
            <i className="ri-calendar-check-fill mr-3 text-2xl"></i>
            Réserver mon entretien gratuit
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
